import { sharedHeaders } from "../utils/constants"

const getResorts = {
  "type": "endpoint",
  "method": "get",
  "title": "Get Resorts",
  "path": "/v1/resorts",
  "description": "Get list of resorts available for insurance purchases",
  "request": {
    "headers": [
      ...sharedHeaders
    ]
  },
  "responses": {
    "200": {
      "description": "Successful response",
      "content": {
        "application/json": {
          "schema": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ResortDto"
            }
          }
        }
      }
    },
    "400": {
      "description": "Bad Request"
    },
    "401": {
      "description": "Unauthorized"
    },
    "500": {
      "description": "Internal Server Error"
    }
  },
  "components": {
    "schemas": {
      "ResortDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "description": "Resort ID",
            "example": "0zOzhkIXNKM0DRjqGj0R"
          },
          "name": {
            "type": "string",
            "description": "Localized resort name",
            "example": "Le Mont Dore"
          },
          "url": {
            "type": "string",
            "description": "Resort URL",
            "example": "https://lemontdore.fr/"
          },
          "sale_period": {
            "type": "object",
            "properties": {
              "start": {
                "type": "string",
                "description": "Sale start date in DD/MM format",
                "example": "01/11"
              },
              "end": {
                "type": "string",
                "description": "Sale end date in DD/MM format",
                "example": "30/04"
              }
            },
            "required": [
              "start",
              "end"
            ]
          },
          "seasons": {
            "type": "object",
            "properties": {
              "summer": {
                "type": "object",
                "properties": {
                  "start": {
                    "type": "string",
                    "description": "Summer season start date in DD/MM format",
                    "example": "01/06"
                  },
                  "end": {
                    "type": "string",
                    "description": "Summer season end date in DD/MM format",
                    "example": "30/09"
                  }
                },
                "required": [
                  "start",
                  "end"
                ]
              },
              "winter": {
                "type": "object",
                "properties": {
                  "start": {
                    "type": "string",
                    "description": "Winter season start date in DD/MM format",
                    "example": "01/11"
                  },
                  "end": {
                    "type": "string",
                    "description": "Winter season end date in DD/MM format",
                    "example": "30/04"
                  }
                },
                "required": [
                  "start",
                  "end"
                ]
              }
            }
          },
          "coordinates": {
            "type": "object",
            "properties": {
              "latitude": {
                "type": "number",
                "description": "Latitude of the resort",
                "example": 45.9237
              },
              "longitude": {
                "type": "number",
                "description": "Longitude of the resort",
                "example": 6.8694
              }
            },
            "required": [
              "latitude",
              "longitude"
            ]
          }
        },
        "required": [
          "id",
          "name",
          "sale_period",
          "seasons"
        ]
      }
    }
  }
}

export { getResorts }
